module.exports = __webpack_public_path__ + "static/media/drone.207b34b7.svg";